// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as $$String from "../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Js_string from "../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Js_promise from "../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as CookieUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/CookieUtils.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as RegexUtils$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/utils/RegexUtils.mjs";
import * as PathHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/PathHelpers.mjs";
import * as FormConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/FormConstants.mjs";
import * as RegexConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/RegexConstants.mjs";
import * as CountryConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/CountryConstants.mjs";
import * as QueryParamsConstructor$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/query-params/QueryParamsConstructor.mjs";

function getError(field) {
  if (field !== undefined && field.TAG !== /* Ok */0) {
    return field._0;
  }
  
}

function handleAPIRequestV2(apiRequest, onSuccess, onError) {
  return Js_promise.then_((function (result) {
                if (result.TAG === /* Ok */0) {
                  return Curry._1(onSuccess, result._0);
                } else {
                  return Curry._1(onError, result._0);
                }
              }), Curry._1(apiRequest, undefined));
}

function addParamsToUrl(url, params) {
  var params_string = params.reduce((function (acc, param, index) {
          return "" + acc + "" + param[0] + "=" + param[1] + "" + (
                  index === (params.length - 1 | 0) ? "" : "&"
                ) + "";
        }), RegexUtils$PorterinUtils.hasParams(url) ? "&" : "?");
  return "" + url + "" + params_string + "";
}

function captilizeWord(word) {
  return Js_string.charAt(0, word).toLocaleUpperCase() + Js_string.sliceToEnd(1, word);
}

function persistQueryParams(url, router) {
  var splitUrl = Js_string.split("?", url);
  var params = Caml_array.get(splitUrl, splitUrl.length - 1 | 0);
  var urlParams = {};
  $$Array.iter((function (param) {
          var params = Js_string.split("=", param);
          if (params.length >= 2) {
            urlParams[Caml_array.get(params, 0)] = Caml_array.get(params, 1);
            return ;
          }
          
        }), Js_string.split("&", params));
  if (!JsBindings$PorterinUtils.isBrowser(undefined)) {
    return "";
  }
  var match = PathHelpers$PorterinUtils.getRoutePathList(router.pathname);
  if (match && match.hd === "fare_estimate_mob" && !match.tl) {
    return "";
  }
  var args = QueryParamsConstructor$Catalyst.create(urlParams);
  if (args !== undefined) {
    return "?" + args;
  } else {
    return "";
  }
}

function stripLeadingZero(mobile, country) {
  if (country === CountryConstants$PorterinUtils.bd) {
    if (mobile.startsWith("0") && mobile.length === 11) {
      return mobile.slice(1);
    } else {
      return mobile;
    }
  } else if (country === CountryConstants$PorterinUtils.ae && mobile.startsWith("0") && mobile.length === 10) {
    return mobile.slice(1);
  } else {
    return mobile;
  }
}

function validateNumber(mobile, country) {
  if (country === CountryConstants$PorterinUtils.bd) {
    var regexMatch = RegexConstants$PorterinUtils.phoneNumberRegexBd.test(mobile);
    if (!regexMatch) {
      return {
              TAG: /* Error */1,
              _0: /* INVALID_MOBILE */0
            };
    }
    var processedMobile = stripLeadingZero(mobile, country);
    if (processedMobile.length === 10) {
      return {
              TAG: /* Ok */0,
              _0: processedMobile
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: /* INVALID_MOBILE */0
            };
    }
  }
  if (country === CountryConstants$PorterinUtils.ae) {
    var regexMatch$1 = RegexConstants$PorterinUtils.phoneNumberRegexUae.test(mobile);
    if (!regexMatch$1) {
      return {
              TAG: /* Error */1,
              _0: /* INVALID_MOBILE */0
            };
    }
    var processedMobile$1 = stripLeadingZero(mobile, country);
    if (processedMobile$1.length === 9) {
      return {
              TAG: /* Ok */0,
              _0: processedMobile$1
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: /* INVALID_MOBILE */0
            };
    }
  }
  if (country !== CountryConstants$PorterinUtils.tr) {
    return {
            TAG: /* Error */1,
            _0: /* INVALID_MOBILE */0
          };
  }
  var regexMatch$2 = RegexConstants$PorterinUtils.phoneNumberRegexTr.test(mobile);
  if (regexMatch$2) {
    return {
            TAG: /* Ok */0,
            _0: mobile
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: /* INVALID_MOBILE */0
          };
  }
}

function validateName(name, error_msg) {
  var match = name.length;
  if (match === 0) {
    return {
            TAG: /* Error */1,
            _0: error_msg
          };
  }
  if (!RegexUtils$PorterinUtils.hasAtleastOneAlphabet(name)) {
    return {
            TAG: /* Error */1,
            _0: error_msg
          };
  }
  var num = name.length;
  if (num > FormConstants$PorterinUtils.max_name_char_length || num < FormConstants$PorterinUtils.min_name_char_length || RegexConstants$PorterinUtils.nameRegex.test(name)) {
    return {
            TAG: /* Error */1,
            _0: error_msg
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: name
          };
  }
}

function getWebTrackingId(param) {
  var web_tracking_id = Js_json.decodeObject(CookieUtils$Catalyst.getCookie("delivery_ck"));
  if (web_tracking_id === undefined) {
    return ;
  }
  var value = Js_dict.get(Caml_option.valFromOption(web_tracking_id), "delivery_ck");
  if (value !== undefined) {
    return String(Caml_option.valFromOption(value));
  }
  
}

function isNumeric(value) {
  var regex = /^\d+$/;
  var _data = regex.exec(value);
  return _data !== null;
}

function isNumberMatched(mobile, pct) {
  if (mobile.length >= 2 && isNumeric(mobile)) {
    return Caml_format.int_of_string($$String.sub(mobile, mobile.length - 2 | 0, 2)) % 100 < pct;
  } else {
    return false;
  }
}

function reloadAfterRecaptchaFailure(isRecaptchaFailed) {
  if (!isRecaptchaFailed) {
    return ;
  }
  if (!Config$PorterinUtils.enable_recaptcha) {
    return ;
  }
  var timer = setTimeout((function (param) {
          window.location.reload();
        }), 3000);
  return (function (param) {
            clearTimeout(timer);
          });
}

function hasAtleastOneAlphabet(word) {
  return /\w*[a-zA-Z]\w*/.test(word);
}

export {
  getError ,
  handleAPIRequestV2 ,
  addParamsToUrl ,
  captilizeWord ,
  persistQueryParams ,
  stripLeadingZero ,
  validateNumber ,
  validateName ,
  getWebTrackingId ,
  isNumeric ,
  isNumberMatched ,
  reloadAfterRecaptchaFailure ,
  hasAtleastOneAlphabet ,
}
/* Config-PorterinUtils Not a pure module */
